import { css } from '@emotion/react'
import { useCallback, useEffect, useRef } from 'react'
import {
    getExploreScrollPosition,
    setExploreScrollPosition,
} from '../../../app-state/state.grid'
import { avatarUrl } from '../../../mfcLogic/avatarPreviewUrl'
import { isTouchDevice } from '../../../utilities/browser'

const rowContainerStyles = css({
    overflow: 'visible !important',
    display: 'flex',
})
const rowContainerTouchStyles = css({
    overflowX: 'scroll !important' as any,
    display: 'flex',
})
const rowStyles = css({
    display: 'inline-block',
    cursor: 'pointer',
    flexShrink: 0,
    flexGrow: 0,
})

const UserRow = (props) => {
    const {
        displayComponentProps,
        saveScrollPosition,
        DisplayComponent,
        SeeAllComponent,
        seeAllOnClick,
        displayHeight,
        SeeAllLabel,
        columnWidth,
        gridPadding,
        rowHeight,
        category,
        getStyle,
        index,
        enableSlide,
        data,
    } = props

    const ref = useRef<HTMLDivElement>(null)
    const scrollLeft = useRef<number>(0)
    const maxWidth = getStyle('column')('maxWidth')
    const stylesSeeAll = getStyle('seeAll')

    const onScroll = useCallback(() => {
        if (!ref.current) return
        scrollLeft.current = ref.current.scrollLeft
    }, [])

    useEffect(() => {
        if (!category || !saveScrollPosition || !ref.current) return
        const scrollPosition = getExploreScrollPosition(category)
        if (scrollPosition) {
            ref.current.scrollLeft = scrollPosition
            scrollLeft.current = scrollPosition
        }
        return () => {
            setExploreScrollPosition(category, scrollLeft.current)
        }
    }, [category, saveScrollPosition])

    if (!data) {
        return null
    }

    return (
        <div
            ref={ref}
            onScroll={saveScrollPosition ? onScroll : undefined}
            className="no-scrollbars"
            css={
                !enableSlide && isTouchDevice
                    ? rowContainerTouchStyles
                    : rowContainerStyles
            }
            style={{
                padding: gridPadding / 2,
            }}
        >
            {data.map((user, i) => {
                const { _key, id } = user
                const lastItem = i === data.length - 1
                return (
                    <div
                        css={rowStyles}
                        style={{
                            height: rowHeight - gridPadding,
                            paddingRight: gridPadding / 2,
                            paddingLeft: gridPadding / 2,
                            width: columnWidth,
                        }}
                        key={_key || id}
                    >
                        {lastItem && SeeAllComponent && (
                            <SeeAllComponent
                                styleOverrides={{
                                    height:
                                        displayHeight ||
                                        rowHeight - gridPadding,
                                    fontSize: stylesSeeAll('fontSize'),
                                }}
                                image={avatarUrl(
                                    id,
                                    maxWidth <= 150 ? 150 : 300,
                                )}
                                onClick={seeAllOnClick}
                                label={SeeAllLabel}
                            />
                        )}
                        {(!lastItem || !SeeAllComponent) && (
                            <DisplayComponent
                                {...displayComponentProps}
                                {...user}
                                index={index}
                            />
                        )}
                    </div>
                )
            })}
        </div>
    )
}

export default UserRow
export { UserRow }
